var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Página no encontrada")]),_c('Alert',{attrs:{"text":'Credenciales incorrectas',"tiempo":2000,"color":'red'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }